import { createSlice } from "@reduxjs/toolkit";

//const token = storage.get("classToken") || "";

const initialState = {
  sectionUpdate: [
    {
      sectionName: "",
      sectionNumber: "",
      instructorEmails: [],
    },
  ],
};

const slice = createSlice({
  name: "sectionUpdate",
  initialState,

  reducers: {
    setSectionUpdate: (state, action) => {
      state.sectionUpdate = action.payload;
    },
    resetSection: (state) => {
      state = initialState;
    },
  },
});

export const { setSectionUpdate, resetSection } = slice.actions;
export default slice.reducer;
